<template>
  <BaseTable
      title="Worker"
      :subtractHeight="subtractHeight"
      :height="height"
      item-key="uid"
      :dto-model="dtoModel"
      store-name="WorkerTable"
      :lang-dictionary="function(text) {return $t(text)}"
      fixed-header
  >
    <template v-slot:top.right="{instance}">
      <v-col cols="2">
      <BaseFieldNumber small v-model="count" label="Number tasks"></BaseFieldNumber>
        </v-col>
      <v-btn @click="sendTestCommand(instance, count)">Send test command</v-btn>
    </template>
  </BaseTable>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";
import commonFunction from "@/commonFunction/commonFunction";
import BaseFieldNumber from "@/components/Base/BaseFieldNumber";

export default {
  name: 'WorkerTable',
  props: {
    subtractHeight: {type: [Number], default: 140},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false},
    dtoModel: {default: 'WorkerListQueryDTO'},
    dto_send_test_command: {type: [String], default: 'WorkerSendTestCommandDTO'},
    filtersInit: {type: Array, default: () => []},
  },

  components: {
    BaseTable,
    BaseFieldNumber,
  },

  computed: {},

  methods: {
    ...commonFunction.mapStoreActions(['WorkerTable/fetchItemList',]),
    updatePage() {
      console.log('updatePage')
      this.WorkerTable_fetchItemList(this.dtoModel)
    },
    sendTestCommand(instance, count) {
      console.log('sendTestCommand', instance, count)
      let dto_command = {
        count: count,
      }
      instance.fetchAction({dto: dto_command, dto_action_model: this.dto_send_test_command})
    },
  },

  async mounted() {
    // console.log('mounted')
    this.timer = setInterval(() => {this.updatePage()}, 5000)
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
    clearInterval(this.timer)
  },

  data() {
    return {
      timer: null,
      count: 10,
    }
  }
}
</script>

<style>
.row_even {
}
</style>


<i18n>
{
  "en": {
    "columns": {
      "uid": "UID",
      "name": "Name",
      "start_time": "Start time",
      "number_processes": "Number of processes",
      "pool_length": "Pool length",
      "success_count": "Success",
      "error_count": "Error",
      "ip": "IP",
      "cpu_percent": "CPU %",
      "mem_percent": "MEM %"
    }
  },
  "de": {
    "columns": {
      "uid": "UID",
      "name": "Name",
      "start_time": "Start time",
      "number_processes": "Number of processes",
      "pool_length": "Pool length",
      "success_count": "Success",
      "error_count": "Error",
      "ip": "IP",
      "cpu_percent": "CPU %",
      "mem_percent": "MEM %"
    }
  }
}

